import { useGetLimitedPartnerUsersPermissionView } from "@vega-api/generated/coinvest-deal-permission/coinvest-deal-permission";
import { type TeaserEmail } from "@vega-api/generated/types/teaserEmail";

import {
  teaserEmailToFormValues,
  userRecipientIds,
} from "../DraftEmail/draftEmailUtils";

type UseSendDraftRowDataParams = {
  dealId: string;
  limitedPartnerId: string;
  draft: TeaserEmail;
};

export function useSendDraftRowData({
  dealId,
  limitedPartnerId,
  draft,
}: UseSendDraftRowDataParams) {
  const accessUsersQuery = useGetLimitedPartnerUsersPermissionView(
    dealId,
    limitedPartnerId,
    {
      query: {
        enabled: !!limitedPartnerId,
        select: (response) => response.data?.users ?? [],
      },
    },
  );

  return {
    accessUsers: accessUsersQuery.data ?? [],
    seedUserIds: userRecipientIds(draft),
    initialValues: teaserEmailToFormValues(draft),
    isLoading: accessUsersQuery.isLoading,
  };
}
